(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ccr-press-page"]) return;
  try {
    
  function ccrSafePressUrl(value) {
    try {
      const url = new URL(value);
      return url.protocol === 'https:' && !url.username && !url.password ? url.href : '';
    } catch {
      return '';
    }
  }
  function ccrBuildPressCard(product, labels) {
    const article = document.createElement('article');
    article.className = 'ccr-press-product-card';

    if (product.image) {
      const image = document.createElement('img');
      image.className = 'ccr-press-product-card__image';
      image.loading = 'lazy';
      image.src = product.image;
      image.alt = product.imageAlt || product.title;
      article.appendChild(image);
    }

    const content = document.createElement('div');
    content.className = 'ccr-press-product-card__content';

    const title = document.createElement('h3');
    title.className = 'h5';
    title.textContent = product.title;
    content.appendChild(title);

    const list = document.createElement('ul');
    list.className = 'ccr-press-product-card__mentions';

    product.mentions.forEach(function(mention, index) {
      const item = document.createElement('li');
      item.className = 'ccr-press-product-card__mention';
      if (index > 1) {
        item.hidden = true;
        item.dataset.extraMention = 'true';
      }

      const publicUrl = ccrSafePressUrl(mention.publicUrl);
      const medium = document.createElement(publicUrl ? 'a' : 'span');
      medium.className = 'ccr-press-product-card__medium';
      medium.textContent = mention.medium;
      if (publicUrl) {
        medium.href = publicUrl;
        medium.target = '_blank';
        medium.rel = 'noopener noreferrer';
      }
      item.appendChild(medium);

      if (mention.context) {
        item.appendChild(document.createTextNode(' — ' + mention.context));
      }

      item.appendChild(document.createTextNode(', ' + mention.dateLabel));
      list.appendChild(item);
    });

    content.appendChild(list);

    if (product.mentions.length > 2) {
      const moreButton = document.createElement('button');
      moreButton.type = 'button';
      moreButton.className = 'ccr-press-product-card__more';
      moreButton.textContent = labels.showMore;
      moreButton.addEventListener('click', function() {
        const isExpanded = moreButton.getAttribute('aria-expanded') === 'true';
        list.querySelectorAll('[data-extra-mention="true"]').forEach(function(item) {
          item.hidden = isExpanded;
        });
        article.classList.toggle('is-expanded', !isExpanded);
        moreButton.setAttribute('aria-expanded', String(!isExpanded));
        moreButton.textContent = isExpanded ? labels.showMore : labels.showLess;
      });
      moreButton.setAttribute('aria-expanded', 'false');
      content.appendChild(moreButton);
    }

    const link = document.createElement('a');
    link.className = 'link';
    link.href = product.url;
    link.textContent = labels.viewProduct;
    content.appendChild(link);

    article.appendChild(content);
    return article;
  }

  function ccrSetupPressCarousel(track) {
    const carousel = track.closest('[data-press-carousel]');
    if (!carousel) return;

    const controls = carousel.querySelector('[data-press-carousel-controls]');
    const previous = carousel.querySelector('[data-press-carousel-prev]');
    const next = carousel.querySelector('[data-press-carousel-next]');
    if (!controls || !previous || !next) return;

    function updateButtons() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      controls.hidden = maxScroll <= 8;
      previous.disabled = track.scrollLeft <= 8;
      next.disabled = track.scrollLeft >= maxScroll - 8;
    }

    function scrollToCard(direction) {
      const cards = Array.from(track.children);
      if (cards.length === 0) return;

      const trackLeft = track.getBoundingClientRect().left;
      const currentLeft = track.scrollLeft;
      const cardPositions = cards.map(function(card) {
        return card.getBoundingClientRect().left - trackLeft + currentLeft;
      });

      let targetIndex = 0;

      if (direction > 0) {
        targetIndex = cardPositions.findIndex(function(left) {
          return left > currentLeft + 8;
        });
        if (targetIndex === -1) targetIndex = cards.length - 1;
      } else {
        for (let index = cardPositions.length - 1; index >= 0; index -= 1) {
          if (cardPositions[index] < currentLeft - 8) {
            targetIndex = index;
            break;
          }
        }
      }

      track.scrollTo({ left: cardPositions[targetIndex], behavior: 'smooth' });
      window.setTimeout(updateButtons, 350);
    }

    previous.addEventListener('click', function() {
      scrollToCard(-1);
    });

    next.addEventListener('click', function() {
      scrollToCard(1);
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    requestAnimationFrame(updateButtons);
  }

  document.querySelectorAll('.ccr-press-page').forEach(function(root) {
    const source = root.querySelector('[data-press-source-list]');
    const latestTarget = root.querySelector('[data-press-products-latest]');
    const mostSeenTarget = root.querySelector('[data-press-products-most-seen]');
    const mostSeenWrapper = root.querySelector('[data-press-most-seen-wrapper]');
    if (!source || !latestTarget || !mostSeenTarget) return;

    const labels = {
      viewProduct: root.dataset.viewProductLabel || '',
      viewArticle: root.dataset.viewArticleLabel || '',
      showMore: root.dataset.showMoreLabel || '',
      showLess: root.dataset.showLessLabel || '',
      singular: root.dataset.mentionSingular || '',
      plural: root.dataset.mentionPlural || ''
    };
    const products = new Map();

    source.querySelectorAll('[data-product-id]').forEach(function(item) {
      const id = item.dataset.productId;
      if (!id) return;

      if (!products.has(id)) {
        products.set(id, {
          id: id,
          title: item.dataset.productTitle || '',
          url: item.dataset.productUrl || '#',
          image: item.dataset.productImage || '',
          imageAlt: item.dataset.productImageAlt || '',
          latestDate: item.dataset.date || '',
          mentions: []
        });
      }

      const product = products.get(id);
      product.latestDate = product.latestDate > item.dataset.date ? product.latestDate : item.dataset.date;
      product.mentions.push({
        date: item.dataset.date || '',
        dateLabel: item.dataset.dateLabel || '',
        medium: item.dataset.medium || '',
        context: item.dataset.context || '',
        publicUrl: item.dataset.publicUrl || ''
      });
    });

    const grouped = Array.from(products.values()).map(function(product) {
      product.mentions.sort(function(a, b) { return b.date.localeCompare(a.date); });
      return product;
    });

    if (!grouped.length) return;

    grouped
      .slice()
      .sort(function(a, b) { return b.latestDate.localeCompare(a.latestDate); })
      .slice(0, 12)
      .forEach(function(product) { latestTarget.appendChild(ccrBuildPressCard(product, labels)); });

    grouped
      .slice()
      .sort(function(a, b) {
        if (b.mentions.length !== a.mentions.length) return b.mentions.length - a.mentions.length;
        return b.latestDate.localeCompare(a.latestDate);
      })
      .slice(0, 10)
      .forEach(function(product) { mostSeenTarget.appendChild(ccrBuildPressCard(product, labels)); });

    ccrSetupPressCarousel(latestTarget);
    ccrSetupPressCarousel(mostSeenTarget);

    if (mostSeenWrapper) mostSeenWrapper.hidden = false;
    root.classList.add('is-enhanced');
  });

  } catch(e) { console.error(e); }
})();
})();
